export default (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="1.33337" y="3.33301" width="13.3333" height="9.33333" stroke="#5F64DE" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M1.33337 3.33301L8.00004 9.33301L14.6667 3.33301" stroke="#5F64DE" />
		<path d="M1.33337 12.6663L6.00004 7.33301" stroke="#5F64DE" />
		<path fillRule="evenodd" clipRule="evenodd" d="M14.6667 12.6663L10 7.33301L14.6667 12.6663Z" stroke="#5F64DE" />
	</svg>
);
